import { Video, type VodVideo } from '@/app_lib/types/Video';
import { formatDate } from '@/app_lib/utils/utils';

function formatDuration(duration: { unit?: string; value?: number }) {
  const value = duration.value ?? 0;
  const unit = duration.unit ?? 'seconds';
  switch (unit) {
    case 'hours': {
      return `${Math.floor(value)}:00:00`;
    }
    case 'minutes': {
      const hours = Math.floor(value / 60);
      const minutes = Math.floor(value % 60);
      return `${hours > 0 ? `${hours}:` : ''}${minutes}:00`;
    }
    default: {
      const hours = Math.floor(value / 3600);
      const minutes = Math.floor((value % 3600) / 60);
      const seconds = Math.floor(value % 60);
      return `${hours > 0 ? `${hours}:` : ''}${minutes}:${seconds.toString().padStart(2, '0')}`;
    }
  }
}

export function convertConferencesVodVideoToVideo(video: VodVideo) {
  return Video.parse({
    age: formatDate(new Date(video.videoPublishDate || video.createdAt).toISOString()),
    duration: formatDuration(video.duration),
    id: video.videoId,
    summary: video.longDescription,
    thumbnail: video.resizedOriginalImages?.[video.resizedOriginalImages.length - 1],
    title: video.name,
    videoUrl: video.videoId,
  });
}
